<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.appLightGrey{
  background-color: #5c6784;
}
.appDarkGrey{
  background-color: #1d263b;
  color: white;
}
.appRed{
  background-color: #e84855;
}
.appOrange{
  background-color: #ff9b71;
}
.txtAppLightGrey{
  color: #5c6784;
}
.txtAppDarkGrey{
  color: #1d263b;
}
.txtAppRed{
  color: #e84855;
}
.txtAppOrange{
  color: #ff9b71;
}
@font-face {
  font-family: 'font devweb';
  src: url('/static/font/font_devweb.eot');
  src: url('/static/font/font_devweb.eot') format('embedded-opentype'),
        url('/static/font/font_devweb.woff') format('woff'),
        url('/static/font/font_devweb.ttf') format('truetype'),
        url('/static/font/font_devweb.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue